<div class="w-full bg-white min-h-16 rounded-xl px-[25px] py-[25px]">
  <div class="flex justify-between items-center">
    <p class="text-18 font-semibold">Type récompense de Quiz</p>
    <span nz-icon nzType="sort-ascending" nzTheme="outline"></span>
  </div>
  <!-- List Area -->
  <div class="flex flex-col gap-2 w-full mt-[20px]">
    <div
      *ngFor="let typeReward of typeRewardList; let i = index"
      class="flex bg-gray-100 rounded-xl p-3 items-center justify-between"
    >
      <!-- label -->
      <p
        *ngIf="!typeReward.isEditing"
        class="font-medium text-base text-gray-500"
      >
        {{ typeReward.label }}
      </p>

      <input
        *ngIf="typeReward.isEditing"
        nz-input
        class="w-1/2 rounded-md text-xl text-gray-400"
        placeholder="Category label"
        [(ngModel)]="typeReward.label"
        type="text"
      />

      <!-- Action Group -->
      <div class="flex gap-5 justify-center items-center">
        <span
          *ngIf="!typeReward.isEditing"
          nz-icon
          nzType="edit"
          nzTheme="outline"
          class="cursor-pointer hover:text-blue-500"
          (click)="editCategory(i)"
        ></span>

        <span
          *ngIf="typeReward.isEditing"
          (click)="updateTypeReward(typeReward.label, i, typeReward.id)"
          nz-icon
          nzType="check"
          nzTheme="outline"
          class="cursor-pointer hover:text-blue-500"
        ></span>

        <span
          (click)="deleteCategory(typeReward.id)"
          nz-icon
          nzType="delete"
          nzTheme="outline"
          class="cursor-pointer hover:text-red-500"
        ></span>
      </div>
    </div>
  </div>

  <div *ngIf="typeRewardList?.length === 0">
    <p>Aucun Type de recompense disponible</p>
  </div>

  <!-- Editor Area -->
  <div class="mt-[10px]">
    <input
      *ngIf="isAdding"
      nz-input
      class="w-full rounded-4 text-lg text-gray-400"
      placeholder="Nouvelle catégorie"
      [(ngModel)]="newAddedValue"
      type="text"
    />
  </div>

  <!-- Adding Area -->
  <div class="mt-[10px] flex gap-3">
    <button
      *ngIf="isAdding"
      nz-button
      (click)="cancelAdding()"
      nzType="primary"
      class="w-full flex justify-center items-center rounded-md gap-4 p-2 bg-red-200 cursor-pointer transition-all hover:bg-red-300/70"
    >
      <p class="font-semibold text-red-400">ANNULER</p>
    </button>

    <button
      nz-button
      nzType="primary"
      *ngIf="!isAdding"
      nz-button
      nzType="primary"
      (click)="toggleAdding()"
      class="w-full flex justify-center items-center mt-3 gap-4 p-2 bg-primary cursor-pointer transition-all hover:bg-primary"
    >
      <span nz-icon nzType="plus" nzTheme="outline" class="text-white"></span>
      <p class="font-semibold text-white">AJOUTER</p>
    </button>

    <button
      *ngIf="isAdding"
      (click)="addRewardType()"
      nz-button
      nzType="primary"
      (ngClass)="(newAddedValue.length > 0 ? 'opacity-100' : 'opacity-50')"
      class="w-full flex justify-center items-center gap-4 p-3 rounded-md bg-blue-500 cursor-pointer transition-all hover:bg-primary"
    >
      <p class="font-semibold text-white">CONFIRMER</p>
    </button>
  </div>
</div>
